import React, { useState, useEffect } from 'react';

const FuecModal = ({ item }) => {
  console.log("📄 PDF - Datos recibidos del padre:", item);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState('');

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Generar código QR usando Google Charts API
 useEffect(() => {
  const generateQRCode = () => {
    try {
      const fuecNumber = item.id;
      const qrData = `https://control.transorientesas.com/pages/comingsoon/Consultar_qr/${fuecNumber}`;
      
      // Usar API pública alternativa - QR Server
      const encodedData = encodeURIComponent(qrData);
      const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=80x80&data=${encodedData}`;
      
      setQrCodeUrl(qrUrl);
    } catch (error) {
      console.error('Error generando QR:', error);
      // Fallback a imagen local o texto
    }
  };

  generateQRCode();
}, [item]);

  // Función para formatear fechas
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return isNaN(date.getTime()) ? '' : date.toLocaleDateString('es-ES');
    } catch {
      return '';
    }
  };

  // Función para extraer día, mes y año de una fecha
  const extractDateParts = (dateString) => {
    if (!dateString) return { day: '', month: '', year: '' };
    
    try {
        // Para formato DD/MM/YYYY
        const parts = dateString.split('/');
        if (parts.length === 3) {
            return {
                day: parts[0].trim(),
                month: parts[1].trim(),
                year: parts[2].trim().split(' ')[0] // Por si hay hora después
            };
        }
        
        // Si no es DD/MM/YYYY, intentamos con el método original
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return { day: '', month: '', year: '' };
        
        // O usar el método local para evitar problemas de zona horaria
        return {
            day: date.getUTCDate().toString(),
            month: (date.getUTCMonth() + 1).toString(),
            year: date.getUTCFullYear().toString()
        };
    } catch {
        return { day: '', month: '', year: '' };
    }
};

  // Procesar datos del conductor
  const procesarConductor = (conductorString) => {
    if (!conductorString) return { nombre: '', cedula: '', licencia: '', vigencia: '' };
    
    const parts = conductorString.split(' ');
    if (parts.length < 4) return { nombre: conductorString, cedula: '', licencia: '', vigencia: '' };
    
    // Asumimos que el primer elemento es la cédula, luego nombre completo, y el último es la vigencia
    const cedula = parts[0];
    const vigencia = parts[parts.length - 1];
    const nombre = parts.slice(1, parts.length - 1).join(' ');
    
    return {
      nombre: nombre || '',
      cedula: cedula || '',
      licencia: cedula || '', // Asumiendo que la licencia es igual a la cédula
      vigencia: formatDate(vigencia) || ''
    };
  };

  // Procesar datos del contrato cliente
  const procesarCliente = (contratoString) => {
    if (!contratoString) return { nit: '', cc: '', nombre: ''};
    
    const parts = contratoString.split('-');
    return {
      nit: parts[0] || '',
      cc: parts[1] || '',
      nombre: parts[2] || ''
    };
  };
  const procesarRecorrido = (contratoString) => {
    if (!contratoString) return { codigo: '', origen: '', destino: ''};
    
    const parts = contratoString.split('|');
    return {
      codigo: parts[0] || '',
      origen: parts[1] || '',
      destino: parts[2] || ''
    };
  };
  const procesarVehiculo = (contratoString) => {
    if (!contratoString) return { placa: '', empresa_afiliada: '', modelo: '', marca: '', clase: '', numero_interno: '', especificaciones: ''};
    
    const parts = contratoString.split('|');
    return {
      placa: parts[0] || '',
      empresa_afiliada: parts[1] || '',
      modelo: parts[2] || '',
      marca: parts[3] || '',
      clase: parts[4] || '',
      numero_interno: parts[5] || '',
      especificaciones: parts[6] || ''
    };
  };
  const procesarContratoCliente = (contratoString) => {
    if (!contratoString) return { numero: '', nombre_responsable: '', cedula_responsable: '', telefono_responsable: '', direccion_responsable: '' , descripcion: ''};
    
    const parts = contratoString.split('|');
    return {
      numero: parts[0] || '',
      nombre_responsable: parts[1] || '',
      cedula_responsable: parts[2] || '',
      telefono_responsable: parts[3] || '',
      direccion_responsable: parts[4] || '',
      descripcion: parts[5] || ''
    };
  };
  const datosCliente = procesarCliente(item.fuec?.contrato_cli);
  const datosContrato = procesarContratoCliente(item.fuec?.numero_contrato);
  const datosConductor1 = procesarConductor(item.fuec?.conductor1);
  const fechaInicioParts = extractDateParts(item.fech_inicio);
  const fechaFinParts = extractDateParts(item.fech_fin);
   const datosRecorrido = procesarRecorrido(item.fuec?.codigo_ciudad);
   const datosVehiculo = procesarVehiculo(item.fuec?.vehiculo);
  const handlePrint = () => {
    const printContent = document.getElementById('fuec-print-content');
    const printWindow = window.open('', '_blank');
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Formato FUEC</title>
          <style>
            @page {
              size: A4;
              margin: 10mm;
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 15px;
              font-size: 10px;
              line-height: 1.2;
              color: #000;
            }
            .fuec-container {
              width: 100%;
              max-width: 100%;
              margin: 0 auto;
              border: 1px solid #ccc;
              padding: 15px;
              box-sizing: border-box;
            }
            .fuec-header {
              text-align: center;
              margin-bottom: 15px;
              border-bottom: 2px solid #2c3e50;
              padding-bottom: 2px;
              position: relative;
            }
            .fuec-title {
              font-size: 11px;
              color: #2c3e50;
              margin-bottom: 6px;
              font-weight: bold;
            }
            .fuec-subtitle {
              font-size: 10px;
              color: #34495e;
              font-weight: normal;
            }
            .qr-code {
              position: absolute;
              right: 0;
              top: 0;
              width: 80px;
              height: 80px;
              border: 1px solid #ccc;
            }
            .fuec-section {
              margin-bottom: 12px;
              padding-bottom: 2px;
              border-bottom: 1px solid #e0e0e0;
              page-break-inside: avoid;
            }
            .section-title {
              font-size: 10px;
              color: #2c3e50;
              margin-bottom: 6px;
              border-bottom: 1px solid #bdc3c7;
              padding-bottom: 2px;
              font-weight: bold;
            }
            .fuec-field {
              display: flex;
              flex-wrap: nowrap;
              margin-bottom: 4px;
              align-items: center;
            }
            .field-label {
              font-weight: bold;
              margin-right: 5px;
              min-width: 120px;
              font-size: 10px;
            }
            .field-value {
              flex: 1;
              font-size: 10px;
            }
            .date-container {
              display: flex;
              gap: 20px;
            }
            .date-field {
              display: flex;
              flex-direction: column;
            }
            .date-values {
              display: flex;
              gap: 6px;
              margin-top: 2px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 6px;
              font-size: 8px;
              page-break-inside: avoid;
            }
            th, td {
              border: 1px solid #000;
              padding: 4px;
              text-align: left;
              font-size: 8px;
            }
            th {
              background-color: #f0f0f0;
              font-weight: bold;
              padding: 4px;
            }
            .vehicle-details {
              display: flex;
              gap: 15px;
              margin-top: 6px;
              flex-wrap: wrap;
            }
            .detail-field {
              display: flex;
              flex-direction: column;
              min-width: 100px;
            }
            .fuec-footer {
              text-align: center;
              margin-top: 15px;
              padding-top: 8px;
              border-top: 2px solid #2c3e50;
              page-break-inside: avoid;
            }
            .footer-text {
              font-weight: bold;
              margin-bottom: 6px;
              font-size: 10px;
            }
            .footer-date {
              font-style: italic;
              font-size: 8px;
            }
            .compact-row {
              margin-bottom: 2px;
            }
            .two-columns {
              display: flex;
              gap: 10px;
            }
            .column {
              flex: 1;
            }
            .small-text {
              font-size: 8px;
            }
            .signature-section {
              margin-top: 10px;
              text-align: center;
            }
            .company-info {
              text-align: center;
              font-size: 8px;
              margin-top: 5px;
              line-height: 1.1;
            }
            @media print {
              body { 
                margin: 0; 
                padding: 10px;
                font-size: 10px;
              }
              .fuec-container {
                border: none;
                padding: 10px;
                margin: 0;
              }
              .no-break {
                page-break-inside: avoid;
              }
            }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    
    printWindow.document.close();
    printWindow.focus();
    
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  const styles = {
    app: {
      backgroundColor: '#f5f5f5',
      padding: '20px',
      minHeight: '100vh'
    },
    btnContainer: {
      textAlign: 'center',
      marginBottom: '20px'
    },
    btn: {
      backgroundColor: '#2c3e50',
      color: 'white',
      border: 'none',
      padding: '12px 24px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '16px',
      transition: 'background-color 0.3s'
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '8px',
      width: '100%',
      maxWidth: '900px',
      maxHeight: '90vh',
      overflowY: 'auto',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '16px 20px',
      borderBottom: '1px solid #e0e0e0',
      backgroundColor: '#f8f9fa'
    },
    modalTitle: {
      color: '#2c3e50',
      fontSize: '1.5rem',
      margin: 0
    },
    modalActions: {
      display: 'flex',
      gap: '10px'
    },
    btnPrint: {
      backgroundColor: '#27ae60',
      color: 'white',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '10px'
    },
    btnClose: {
      backgroundColor: '#e74c3c',
      color: 'white',
      border: 'none',
      padding: '8px 16px',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '10px'
    },
    fuecContainer: {
      padding: '15px',
      fontSize: '9px',
      lineHeight: '1.2'
    },
    fuecHeader: {
      textAlign: 'center',
      marginBottom: '15px',
      borderBottom: '2px solid #2c3e50',
      paddingBottom: '2px',
      position: 'relative'
    },
    fuecTitle: {
      fontSize: '11px',
      color: '#2c3e50',
      marginBottom: '6px'
    },
    fuecSubtitle: {
      fontSize: '10px',
      color: '#34495e',
      fontWeight: 'normal'
    },
    qrCode: {
      /* position: 'absolute', */
      right: '0',
      top: '0',
      width: '80px',
      height: '80px',
      border: '1px solid #ccc',
      padding: '2px',
      backgroundColor: 'white'
    },
    fuecSection: {
      marginBottom: '12px',
      paddingBottom: '2px',
      borderBottom: '1px solid #e0e0e0'
    },
    sectionTitle: {
      fontSize: '10px',
      color: '#2c3e50',
      marginBottom: '6px',
      borderBottom: '1px solid #bdc3c7',
      paddingBottom: '2px'
    },
    fuecField: {
      display: 'flex',
      flexWrap: 'nowrap',
      marginBottom: '4px',
      alignItems: 'center'
    },
    fieldLabel: {
      fontWeight: 'bold',
      marginRight: '5px',
      minWidth: '120px',
      fontSize: '9px'
    },
    fieldValue: {
      flex: 1,
      fontSize: '9px'
    },
    dateContainer: {
      display: 'flex',
      gap: '20px'
    },
    dateField: {
      display: 'flex',
      flexDirection: 'column'
    },
    dateValues: {
      display: 'flex',
      gap: '6px',
      marginTop: '2px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '6px',
      fontSize: '8px'
    },
    tableHeader: {
      backgroundColor: '#ecf0f1',
      fontWeight: 'bold'
    },
    tableCell: {
      border: '1px solid #bdc3c7',
      padding: '4px',
      textAlign: 'left',
      fontSize: '8px'
    },
    vehicleDetails: {
      display: 'flex',
      gap: '15px',
      marginTop: '6px',
      flexWrap: 'wrap'
    },
    detailField: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: '100px'
    },
    fuecFooter: {
      textAlign: 'center',
      marginTop: '15px',
      paddingTop: '8px',
      borderTop: '2px solid #2c3e50'
    },
    footerText: {
      fontWeight: 'bold',
      marginBottom: '6px',
      fontSize: '9px'
    },
    footerDate: {
      fontStyle: 'italic',
      fontSize: '8px'
    },
    compactRow: {
      marginBottom: '2px'
    },
    twoColumns: {
      display: 'flex',
      gap: '10px'
    },
    column: {
      flex: 1
    },
    smallText: {
      fontSize: '8px'
    },
    signatureSection: {
      marginTop: '10px',
      textAlign: 'center'
    },
    companyInfo: {
      textAlign: 'center',
      fontSize: '8px',
      marginTop: '5px',
      lineHeight: '1.1'
    }
  };

  return (
    <div style={styles.app}>
      <div style={styles.modalHeader}>
        <h2 style={styles.modalTitle}>Vista Previa - Formato FUEC</h2>
        <div style={styles.modalActions}>
          <button 
            style={styles.btnPrint}
            onMouseOver={(e) => e.target.style.backgroundColor = '#219652'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#27ae60'}
            onClick={handlePrint}
          >
            Imprimir
          </button>
         
        </div>
      </div>
      
      <div id="fuec-print-content" style={styles.fuecContainer}>
        <div style={styles.fuecHeader}>
        
          
          <h1 style={styles.fuecTitle}>FICHA DEL FORMATO DEL EXTRACTO DEL CONTRATO "FUEC"</h1>
          <img src={require("../../assets/images/logo_fuec.png")} alt="" style={{ width: '100%', maxWidth: '700px', height: 'auto', textAlign: "center" }} />
          <h2 style={styles.fuecSubtitle}>FORMATO ÚNICO DEL EXTRACTO DEL CONTRATO DEL SERVICIO PÚBLICO DE TRANSPORTE TERRESTRE AUTOMOTOR ESPECIAL</h2>
        </div>

        <div style={styles.fuecSection}>
          <div style={styles.fuecField}>
            <span style={styles.fieldLabel}>FUEC No.:</span>
            <span style={styles.fieldValue}>{item.numero || item.fuec?.numero}</span>
          </div>
        </div>

        <div style={styles.twoColumns}>
          <div style={styles.column}>
            <div style={styles.fuecField}>
              <span style={styles.fieldLabel}>EMPRESA:</span>
              <span style={styles.fieldValue}>TRANSPORTES ESPECIALES DEL ORIENTE S.A.S</span>
            </div>
            <div style={styles.fuecField}>
              <span style={styles.fieldLabel}>NIT:</span>
              <span style={styles.fieldValue}>900645942-6</span>
            </div>
          </div>
          <div style={styles.column}>
            <div style={styles.fuecField}>
              <span style={styles.fieldLabel}>CONTRATO No.:</span>
              <span style={styles.fieldValue}>{datosContrato.numero}</span>
            </div>
          </div>
        </div>

        <div style={styles.fuecSection}>
          <div style={styles.fuecField}>
            <span style={styles.fieldLabel}>CONTRATANTE:</span>
            <span style={styles.fieldValue}>{datosCliente.nombre}</span>
          </div>
          <div style={styles.fuecField}>
            <span style={styles.fieldLabel}>NIT/CC:</span>
            <span style={styles.fieldValue}>{datosCliente.cc}</span>
          </div>
        </div>

        <div style={styles.fuecSection}>
          <div style={styles.fuecField}>
            <span style={styles.fieldLabel}>OBJETO:</span>
            <span style={{...styles.fieldValue, ...styles.smallText}}>{datosContrato.descripcion} {item.objeto_extra}</span>
          </div>
        </div>

        <div style={styles.twoColumns}>
          <div style={styles.column}>
            <div style={styles.fuecField}>
              <span style={styles.fieldLabel}>ORIGEN:</span>
              <span style={{...styles.fieldValue, ...styles.smallText}}>{datosRecorrido.origen}</span>
            </div>
          </div>
          <div style={styles.column}>
            <div style={styles.fuecField}>
              <span style={styles.fieldLabel}>DESTINO:</span>
              <span style={{...styles.fieldValue, ...styles.smallText}}>{datosRecorrido.destino}</span>
            </div>
          </div>
        </div>

        <div style={styles.fuecSection}>
          <div style={styles.fuecField}>
            <span style={styles.fieldLabel}>CONVENIO:</span>
            <span style={styles.fieldValue}>{datosVehiculo.empresa_afiliada}</span>
          </div>
        </div>

        <div style={styles.fuecSection}>
          <h3 style={styles.sectionTitle}>VIGENCIA DEL CONTRATO</h3>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{...styles.tableCell, ...styles.tableHeader}}></th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>DÍA</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>MES</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>AÑO</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.tableCell}>FECHA DE INICIO</td>
                <td style={styles.tableCell}>{fechaInicioParts.day}</td>
                <td style={styles.tableCell}>{fechaInicioParts.month}</td>
                <td style={styles.tableCell}>{fechaInicioParts.year}</td>
              </tr>
              <tr>
                <td style={styles.tableCell}>FECHA DE VENCIMIENTO</td>
                <td style={styles.tableCell}>{fechaFinParts.day}</td>
                <td style={styles.tableCell}>{fechaFinParts.month}</td>
                <td style={styles.tableCell}>{fechaFinParts.year}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={styles.fuecSection}>
          <h3 style={styles.sectionTitle}>CARACTERÍSTICAS DEL VEHÍCULO</h3>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>PLACA</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>MODELO</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>MARCA</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>CLASE</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>NUMERO INTERNO</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>TARJETA OPERACIÓN</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.tableCell}>{datosVehiculo.placa}</td>
                <td style={styles.tableCell}>{datosVehiculo.modelo}</td>
                <td style={styles.tableCell}>{datosVehiculo.clase}</td>
                <td style={styles.tableCell}>{datosVehiculo.marca}</td>  
                <td style={styles.tableCell}>{datosVehiculo.numero_interno}</td>
                <td style={styles.tableCell}>{item.fuec.tarjeta_operacion}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={styles.fuecSection}>
          <h3 style={styles.sectionTitle}>DATOS DEL CONDUCTOR</h3>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>CONDUCTOR</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>NOMBRES Y APELLIDOS</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>No CÉDULA</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>No LICENCIA</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>VIGENCIA</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.tableCell}>1</td>
                <td style={styles.tableCell}>{datosConductor1.nombre}</td>
                <td style={styles.tableCell}>{datosConductor1.cedula}</td>
                <td style={styles.tableCell}>{datosConductor1.licencia}</td>
                <td style={styles.tableCell}>{datosConductor1.vigencia}</td>
              </tr>
              <tr>
                <td style={styles.tableCell}>2</td>
                <td style={styles.tableCell}>{item.id_cond2_name}</td>
                <td style={styles.tableCell}></td>
                <td style={styles.tableCell}></td>
                <td style={styles.tableCell}></td>
              </tr>
              <tr>
                <td style={styles.tableCell}>3</td>
                <td style={styles.tableCell}>{item.id_cond3_name}</td>
                <td style={styles.tableCell}></td>
                <td style={styles.tableCell}></td>
                <td style={styles.tableCell}></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={styles.fuecSection}>
          <h3 style={styles.sectionTitle}>RESPONSABLE DEL CONTRATANTE</h3>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>NOMBRES Y APELLIDOS</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>No CÉDULA</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>TELÉFONO</th>
                <th style={{...styles.tableCell, ...styles.tableHeader}}>DIRECCIÓN</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.tableCell}>{datosContrato.nombre_responsable}</td>
                <td style={styles.tableCell}>{datosContrato.cedula_responsable}</td>
                <td style={styles.tableCell}>{datosContrato.telefono_responsable}</td>
                <td style={styles.tableCell}>{datosContrato.direccion_responsable}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={styles.fuecFooter}>
          <table style={styles.table}>
            <tbody>
              <tr>
                <td style={styles.tableCell}>
                  <p style={styles.footerText}>FORMATO ÚNICO DEL EXTRACTO DEL CONTRATO SEGÚN DECRETO 0348 DE 2015 Y RESOLUCIÓN 0006652 DE 2019</p>
                  <div style={styles.footerDate}>
                    FECHA DE ELAB: {formatDate(item.fecha_registro)}
                  </div>
                </td>
                <td style={{...styles.tableCell, textAlign: 'center', width: '40%'}}>
                  <img src={require("../../assets/images/firma.png")} alt="" style={{ width: '100%', maxWidth: '200px', height: 'auto' }} />
                </td>
              </tr>
            </tbody>
          </table>
          
          <div style={styles.companyInfo}>
            TRANSPORTES ESPECIALES DEL ORIENTE S.A.S<br />
            CALLE 64A # 21 - 50 EDIF. PORTAL DEL CABLE<br />
            TEL. 3045049860 - 3046690903<br />
            MANIZALES - CALDAS<br></br>
              {/* QR Code usando Google Charts API */}
          {qrCodeUrl && (
            <img 
              src={qrCodeUrl} 
              alt="Código QR FUEC" 
              style={styles.qrCode}
            />
          )}
          </div>
        </div>
        <img src={require("../../assets/images/parte_trasera.png")} alt="" style={{ width: '100%', height: 'auto' }} />
      </div>
    </div>
  );
};

export default FuecModal;